<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>Loan Assessment</base-card-heading>
      <base-button secondary small :to="{ name: 'projects.dashboard.terms', params: { id: project._id } }">
        Edit Terms
      </base-button>
    </template>
    <base-stats v-model="stats" />
    <base-table>
      <colgroup>
        <col width="25%" />
        <col width="25%" />
        <col width="25%" />
        <col width="25%" />
      </colgroup>
      <thead>
        <tr>
          <th class="text-center" colspan="2">Facility</th>
          <th class="text-center" colspan="2">Fees &amp; Rates</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Total Facility</th>
          <td>{{ $formatting.toCurrency(project.facility.amount) }}</td>
          <th>Interest Rate</th>
          <td>{{ interestRates }}</td>
        </tr>
        <tr>
          <th>Charge</th>
          <td>{{ project.facility.security }}</td>
          <th>Non-utilisation</th>
          <td>{{ project.facility.nonUtilRate }}%</td>
        </tr>
        <tr>
          <th>Term</th>
          <td>{{ project.facility.term }} month{{ project.facility.term !== 1 ? 's' : '' }}</td>
          <th>Lending Fee</th>
          <td>{{ lendingFees }}</td>
        </tr>
      </tbody>
    </base-table>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  created () {
    const returns = this.facility.finalStatement.fees
      .plus(this.facility.finalStatement.interestAccrued)
      .toFixed(2)

    this.stats = [
      {
        stat: this.$formatting.toCurrency(this.facility.finalStatement.fees.toFixed(2)),
        text: 'Total Fees',
        tooltip: 'All fees in the facility totalled'
      },
      {
        stat: this.$formatting.toCurrency(this.facility.finalStatement.interestAccrued.toFixed(2)),
        text: 'Total Interest',
        tooltip: 'Total interest accrued from facility'
      },
      {
        stat: this.$formatting.toCurrency(returns),
        text: 'Total Returns',
        tooltip: 'Total returns from facility, total fees + interest accrued'
      }
    ]
  },

  data: () => ({
    stats: []
  }),

  name: 'ProjectLoanAssessment',

  props: {
    facility: Object
  },

  computed: {
    lendingFees () {
      const fees = []

      this.project.facility.fees.forEach((fee, i) => {
        if (fee.fee === 'LendingFee') {
          fees.push(this.calculateFee(fee))
        }
      })

      return this.$formatting.toCurrency(this.$_.sum(fees))
    },

    interestRates () {
      const rates = []

      this.project.facility.loans.forEach(({ interest }, i) => {
        rates.push(`${interest}% (${this.$formatting.toOrdinal(i + 1)} loan)`)
      })

      return rates.join(', ')
    },

    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    calculateFee (fee) {
      switch (fee.calculation) {
        case 'FixedFee':
          return fee.amount
        case 'PercentageOfFacility':
          return this.$_.toNumber(this.$big(fee.amount).div(100).times(this.project.facility.amount).toFixed(2))
        case 'PercentageOfGDV':
          return this.$_.toNumber(this.$big(fee.amount).div(100).times(this.project.financials.gdv).toFixed(2))
        default:
          return 0
      }
    }
  }
}
</script>
